module.exports = __webpack_public_path__ + "videos/quickshape-en.b7178e2.mp4";